/*=========================================================================================
	File Name: moduleCalendarMutations.js
	Description: Calendar Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
	ADD_ITEM_USER(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		state.Users.push(Object.assign({}, Object.fromEntries(output)))
	},
	USER_LIST(state, value) {
		state.Users = value;
	},
	DELETE_ITEM_USER(state, item) {
		const index = state.Users.findIndex(i => i.UserId === item)
		if (index > -1) { state.Users.splice(index, 1) }
	}
}
